import api from "../utils/api";

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    getIntegrations() {
      return api.get(`integrations`);
    },
    getLooxMessageLog(context, payload) {
      return api.get(`integrations/messagelogs/loox?page=${payload.page}`);
    },
    getLooxScheduledMessages(context, payload) {
      return api.get(`integrations/scheduled/loox?page=${payload.page}`);
    },
    sendLooxMessage(context, payload) {
      return api.post(`integrations/send/loox/${payload.jobId}`);
    }
  },
  getters: {}
};
